import $ from 'jquery';

$('.dsp-toggle').on('click', function (e) {
  e.stopPropagation();

  const toggle = $(this);

  const toggleID = toggle.data('toggle-target');
  const toggleGroup = toggle.data('toggle-group');
  const isActive = toggle.hasClass('is-active');
  const selfToggle = toggle.hasClass('dsp-self-toggle');

  if (selfToggle && isActive) {
    // shut them all off
    $(`[data-toggle-group=${toggleGroup}]`).removeClass('is-active');
  } else {
    // shut them all off
    $(`[data-toggle-group=${toggleGroup}]`).removeClass('is-active');

    // all toggles that control this toggleID
    const toggles = $(`[data-toggle-target=${toggleID}]`);

    toggles.each(function () {
      $(this).addClass('is-active');
    });

    if (toggle.hasClass('is-multi')) {
      const targets = $(`.${toggleID}`);
      targets.each(function () {
        $(this).addClass('is-active');
      });
    } else {
      const target = $(`#${toggleID}`);
      target.addClass('is-active');
    }
  }
});

$('.dsp-toggle-all-on').on('click', function (e) {
    e.stopPropagation();
    const toggle = $(this);
    const toggleGroup = toggle.data('toggle-group');
    $(`[data-toggle-group=${toggleGroup}]`).addClass('is-active');
});

$('.dsp-toggle-all-off').on('click', function (e) {
    e.stopPropagation();
    const toggle = $(this);
    const toggleGroup = toggle.data('toggle-group');
    $(`[data-toggle-group=${toggleGroup}]`).removeClass('is-active');
});

// EV Overview Toggles

// Click on Model
$('.model-savings__toggle').on('click', function () {
  const toggle = $(this);
  const toggleID = toggle.data('toggle-target');
  const $pane = $(`#${toggleID}`);
  // select first trim
  $pane.find('.model-savings-trims').children(':first').trigger('click');
});

// Click on Trim
$('.model-savings-trims__toggle').on('click', function () {
  const toggle = $(this);
  const toggleID = toggle.data('toggle-target');
  const $pane = $(`#${toggleID}`);
  // select first battery
  $pane.find('.model-savings__grid').children(':first').trigger('click');
});

// VDP Description Toggles

$('.js-description-toggle').on('click', function() {
  const toggle = $(this);
  const toggleState = toggle.data('toggle-target');
  const parentContainer = $('.description-container');
  parentContainer.removeClass('description-less').removeClass('description-more');
  parentContainer.addClass(`description-${toggleState}`);
});
